import { createRouter, createWebHashHistory, NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import store from '@scripts/store/store'
import { Lazy } from '../type'

// 路由组件定义

const history = createWebHashHistory()    // 使用hash模式
const tabStore = new Lazy(() => (store.useTab())) // 使用懒加载模式，定义选项卡状态变量

// 导出路由表
export const router = createRouter({
  history,
  routes: [
    {
      path: '/login',   // 路由路径
      name: 'Login',    // 路由名称，必须使用组件全名，且区分大小写（系统会根据此名称判断视图是否缓存）
      component: () => import('@views/login/Login.vue'),  // 组件
      meta: {
        title: '商户登录' // 视图标题
      }
    },
    {
      path: '/redirect',  // 重定向页面，使用query方式接收参数，直接跳转到指定的视图，页面不会缓存，多用于视图的刷新
      name: 'Redirect',
      component: () => import('@views/other/Redirect.vue'),
    },
    {
      path: '/good',
      name: 'Good',
      component: () => import('@views/good/Good.vue'),
      meta: {
        title: '商品管理'
      }
    },
    {
      path: '/stock',
      name: 'Stock',
      component: () => import('@views/stock/Stock.vue'),
      meta: {
        title: '商品库存'
      }
    },
    {
      path: '/good/detail/:id/:title',    // 使用param方式接收参数
      name: 'GoodDetail',
      component: () => import('@views/good/detail/GoodDetail.vue'),
      meta: {
        title: '商品'
      }
    },
    {
      path: '/order',
      name: 'Order',
      component: () => import('@views/order/Order.vue'),
      meta: {
        title: '订单管理'
      }
    },
    {
      path: '/',
      redirect: '/store',
      name: 'Home',
      children: [
        {
          path: 'store',
          name: 'Home',
          component: () => import('@views/home/Home.vue'),
          meta: {
            title: '今日一览'
          }
        },
        {
          path: 'store/userCenter',
          name: 'UserCenter',
          component: () => import('@views/store/UserCenter.vue'),
          meta: {
            title: '商户中心'
          }
        }
      ]
    },
    {
      path: '/basicData',
      name: 'BasicData',
      component: () => import('@views/basicData/BasicData.vue'),
      meta: {
        title: '商户数据维护'
      }
    },
    {
      path: '/printer',
      name: 'Printer',
      component: () => import('@views/printer/Printer.vue'),
      meta: {
        title: '打印机管理'
      }
    },
    {
      path: '/desk',
      name: 'Desk',
      component: () => import('@views/desk/Desk.vue'),
      meta: {
        title: '餐台管理'
      }
    },
    {
      path: '/staff',
      name: 'Staff',
      component: () => import('@views/setting/staff/Staff.vue'),
      meta: {
        title: '员工管理'
      }
    },
    {
      path: '/storeManager',
      name: 'StoreManager',
      component: () => import('@views/storeManager/StoreManager.vue'),
      meta: {
        title: '商户管理'
      }
    },
    {
      path: '/storeActivity',
      name: 'StoreActivity',
      component: () => import('@views/storeActivity/StoreActivity.vue'),
      meta: {
        title: '外卖活动'
      }
    },
    {
      path: '/marketing',
      name: 'Marketing',
      component: () => import('@views/marketing/Marketing.vue'),
      meta: {
        title: '积分商城'
      }
    },
    {
      path: '/member',
      name: 'Member',
      component: () => import('@views/member/Member.vue'),
      meta: {
        title: '会员中心'
      }
    },
    {
      path: '/book',
      name: 'Book',
      component: () => import('@views/book/Book.vue'),
      meta: {
        title: '记事本'
      }
    },
    {
      path: '/outOrder',
      name: 'OutOrder',
      component: () => import('@views/outOrder/OutOrder.vue'),
      meta: {
        title: '外卖订单'
      }
    },
    {
      path: '/comment',
      name: 'Comment',
      component: () => import('@views/comment/Comment.vue'),
      meta: {
        title: '外卖评价'
      }
    },
    {
      path: '/report',
      redirect: '/report/order',
      name: 'OrderStatistic',
      children: [
        {
          path: '/report/order',
          name: 'OrderStatistic',
          component: () => import('@views/report/orderStatistic/OrderStatistic.vue'),
          meta: {
            title: '订单统计'
          }
        },
        {
          path: '/report/cook',
          name: 'CookStatistic',
          component: () => import('@views/report/cookStatistic/CookStatistic.vue'),
          meta: {
            title: '厨师统计'
          }
        },
        {
          path: '/report/good',
          name: 'GoodStatistic',
          component: () => import('@views/report/goodStatistic/GoodStatistic.vue'),
          meta: {
            title: '商品销售统计'
          }
        },
        {
          path: '/report/stall',
          name: 'StallStatistic',
          component: () => import('@views/report/entityStatistic/StallStatistic.vue'),
          meta: {
            title: '档口统计'
          }
        },
        {
          path: '/report/cashier',
          name: 'CashierStatistic',
          component: () => import('@views/report/cashierStatistic/CashierStatistic.vue'),
          meta: {
            title: '收银员统计'
          }
        },
        {
          path: '/report/outOrder',
          name: 'OutOrderStatistic',
          component: () => import('@views/report/orderStatistic/OutOrderStatistic.vue'),
          meta: {
            title: '外卖订单统计'
          }
        },
        {
          path: '/report/outGood',
          name: 'OutGoodStatistic',
          component: () => import('@views/report/goodStatistic/OutGoodStatistic.vue'),
          meta: {
            title: '外卖商品销售统计'
          }
        },
        {
          path: '/report/outCook',
          name: 'OutCookStatistic',
          component: () => import('@views/report/cookStatistic/OutCookStatistic.vue'),
          meta: {
            title: '外卖厨师统计'
          }
        },
        {
          path: '/report/outStall',
          name: 'OutStallStatistic',
          component: () => import('@views/report/entityStatistic/OutStallStatistic.vue'),
          meta: {
            title: '外卖档口统计'
          }
        },
        {
          path: '/report/mallOrder',
          name: 'MallOrderStatistic',
          component: () => import('@views/report/orderStatistic/MallOrderStatistic.vue'),
          meta: {
            title: '商城订单统计'
          }
        },
        {
          path: '/report/mallGood',
          name: 'MallGoodStatistic',
          component: () => import('@views/report/goodStatistic/MallGoodStatistic.vue'),
          meta: {
            title: '商城商品销售统计'
          }
        },
        {
          path: '/report/orderGoodCancelStatistic',
          name: 'OrderGoodCancelStatistic',
          component: () => import('@views/report/cancelStatistic/StoreOrderGoodCancel.vue'),
          meta: {
            title: '堂食-退菜统计'
          }
        },
        {
          path: '/report/outOrderGoodCancelStatistic',
          name: 'OutOrderGoodCancelStatistic',
          component: () => import('@views/report/cancelStatistic/OutOrderGoodCancel.vue'),
          meta: {
            title: '外卖-退菜统计'
          }
        },
      ]
    },
    {
      path: '/platform',
      redirect: '/platform/jdOrder',
      name: 'JingdongOrder',
      children: [
        {
          path: '/platform/jdMapping',
          name: 'JingdongMapping',
          component: () => import('@views/platform/jingdong/mapping/JingdongMapping.vue'),
          meta: {
            title: '京东商品映射'
          }
        },
        {
          path: '/platform/jdOrder',
          name: 'JingdongOrder',
          component: () => import('@views/platform/jingdong/order/JingdongOrder.vue'),
          meta: {
            title: '京东订单'
          }
        },
      ]
    },
    {
      path: '/material',
      name: 'Material',
      component: () => import('@views/setting/material/Material.vue'),
      meta: {
        title: '物料管理'
      }
    },
    {
      path: '/mall',
      redirect: '/mall/good',
      name: 'MallGood',
      children: [
        {
          path: '/mall/good',
          name: 'MallGood',
          component: () => import('@src/views/mall/good/MallGood.vue'),
          meta: {
            title: '商城商品'
          }
        },
        {
          path: '/mall/order',
          name: 'MallOrder',
          component: () => import('@src/views/mall/order/MallOrder.vue'),
          meta: {
            title: '商城订单'
          }
        }
      ]
    },
    {
      path: '/log',
      name: 'Log',
      component: () => import('@views/logger/Logger.vue'),
      meta: {
        title: '日志'
      }
    },
    {
      path: '/businessStatistic',
      name: 'BusinessStatistic',
      component: () => import('@views/report/businessStatistic/BusinessStatistic.vue'),
      meta: {
        title: '营业统计'
      }
    },
    {
      path: '/:pathMatch(.*)*',   // 无法匹配到的路由，显示此页面
      name: '404',
      component: () => import('@views/other/404.vue'),
      meta: {
        title: '404'
      }
    }
  ]
})

// 路由守卫
export async function onBeforeEach(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  // 跳转前先关闭所有的模态框、信息、消息提示
  // $util.modal.destroyAll()
  $util.message.destroy()
  $util.notify.destroy()
  // 如果是登录页面，则直接跳转
  if (to.path.toLowerCase() === '/login') return next()

  try {
    next()
    if (to.path === '/redirect') return // redirect页不用写入tabs
    // 跳转完成后，将路由写入选项卡
    tabStore.value.push(to)
  } catch (e) {
    // 如果出现异常，则直接跳转到登录页面
    next('/login')
  }
}
